export default __webpack_public_path__ + "static/media/040-yacht.9465a5f1.svg";